import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home/:cemetery?`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cem-home" */ './views/home.vue'),
        meta: {
            auth: undefined,
            title: `home.title`,
        },
    },
];

export default routes;